import { methodColor } from '../../utils/httpColors';

interface MethodBadgeProps {
  method: string;
}

/** Fixed width, wide enough for OPTIONS, so paths line up in lists (docs/brand.md → Badge style). */
export function MethodBadge({ method }: MethodBadgeProps) {
  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center w-[4.5rem] px-1.5 py-0.5 rounded-selector font-mono font-medium text-xs uppercase ${methodColor(method).badge}`}
    >
      {method.toUpperCase()}
    </span>
  );
}
